import React, { Component } from "react";
import { remove, uniq, clone } from "lodash";
import { style } from "typestyle";

import {
  listEditorContainerCN,
  labelListEditorContainerCN,
  wrapperEditableListCN,
} from "./styles";

import EmailInput from "./EmailInput";
import EditableItem from "./EditableItem";

interface Props {
  labelName: string;
  onChangeList: (dataList: Array<string>) => void;
  dataList: Array<string>;
  inputHintText: string;
}

export default class ListMailsEditorControl extends Component<Props> {
  handleAddText = (text: string) => {
    this.addItem(text);
  };

  simpleValidate = (text: string) => {
    return !!text;
  };

  addItem = (text: string) => {
    if (this.simpleValidate(text)) {
      let dataList = clone(this.props.dataList);
      dataList.push(text);
      this.handleChangeList(dataList);
    }
  };

  handleChangeList = (dataList: Array<string>) => {
    this.props.onChangeList(uniq(dataList));
  };

  handleChangeItem = (key: number, text: string) => {
    let dataList = clone(this.props.dataList);
    dataList[key] = text;
    this.handleChangeList(dataList);
  };

  handleRemoveItem = (key: number) => {
    let dataList = clone(this.props.dataList);
    remove(dataList, (item, k) => k === key);
    this.handleChangeList(dataList);
  };

  render() {
    const { labelName, inputHintText, dataList } = this.props;
    return (
      <div className={listEditorContainerCN()}>
        <label className={labelListEditorContainerCN()}>{labelName}</label>
        <div className={style({ background: "#FFFFFF", borderRadius: "2px" })}>
          <EmailInput
            placeholder={inputHintText}
            name={labelName.trim().toLowerCase()}
            value=""
            onAddText={this.handleAddText.bind(this)}
          />
        </div>
        <div className={wrapperEditableListCN()}>
          {dataList.map((item, key) => {
            return (
              <div key={key}>
                <EditableItem
                  value={item}
                  onChange={this.handleChangeItem.bind(this, key)}
                  onRemove={this.handleRemoveItem.bind(this, key)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
